import { Component } from 'react';

class Logout extends Component {
	componentWillMount() {
		localStorage.clear();
		sessionStorage.clear();
		window.location.replace('/');
	}
}

export default Logout;


// WEBPACK FOOTER //
// ./src/components/Logout.js